var cookieTrigger = document.getElementsByClassName("cookie_ok")[0];
const cookieBanner = document.getElementsByClassName("cookiebanner")[0];

// console.log(cookieTrigger);
// console.log(cookieBanner);
// var cookieTrigger = $(".cookie_ok");
// const cookieBanner = $(".cookiebanner");
const cookie_state = getCookie("CookieAgreed");
const expireTime = 30;

// GET COOKIE
function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}

// SET COOKIE
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";

  // Local Storage
  localStorage.setItem("optin-analytics", "true");
  localStorage.setItem("optin-retargeting", "true");
  localStorage.setItem("tracking-level", "retargeting");
  localStorage.setItem("optin-timestamp", d.getTime().toString());

  // DataLayer
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "user consent save",
  });
  // console.log(dataLayer);
}

if (cookie_state == undefined || cookie_state === "0") {
  // cookieBanner.addClass("is-active");
  cookieBanner.classList.add("is-active");
  cookieTrigger.addEventListener("click", function () {
    setCookie("CookieAgreed", 1, expireTime);
    cookieBanner.classList.remove("is-active");
    // cookieBanner.removeClass("is-active");
    // console.log(cookieBanner);
  });
}

if (cookie_state === "1") {
  cookieBanner.classList.remove("is-active");
  // cookieBanner.removeClass("is-active");
}
